/* Feed Finder — KP custom feed form (front end only; no data is sent yet).
   One inline form, part of the page. Every question stays visible; you work
   down it. Custom blend only, never a premade product. The blend block fills
   in live as the questions are answered. Instance based. */
(function(){
  var WORKLOADS = [
    {k:'spelling', t:'Spelling or resting', s:'paddock, downtime, let down'},
    {k:'pretrain', t:'Pre training', s:'coming back into work'},
    {k:'training', t:'In full training', s:'working most days'},
    {k:'racing', t:'Racing', s:'competing now'},
    {k:'breeding', t:'Breeding or young stock', s:'broodmares, weanlings, yearlings'}
  ];
  var WEIGHTS = [
    {k:'light', t:'On the lighter side', s:'under about 450 kg'},
    {k:'avg', t:'About average', s:'450 to 550 kg'},
    {k:'heavy', t:'A big horse', s:'over about 550 kg'},
    {k:'unsure', t:'Not sure', s:'we will estimate it'}
  ];
  var DOERS = [
    {k:'easy', t:'Keeps weight easily', s:'a good doer'},
    {k:'ok', t:'Holds condition fine', s:'right where you want'},
    {k:'hard', t:'Struggles to keep weight on', s:'a hard keeper'}
  ];
  var ISSUES = [
    {k:'fizzy', t:'Gets fizzy or hot'},
    {k:'tieup', t:'Ties up'},
    {k:'gut', t:'Gut or ulcers'},
    {k:'hoof', t:'Hoof or coat'},
    {k:'none', t:'None of these'}
  ];
  var BLEND = {
    spelling:{head:'A calm, low energy custom blend', work:'resting up'},
    pretrain:{head:'A building custom blend', work:'coming back into work'},
    training:{head:'A high energy custom blend', work:'in full training'},
    racing:{head:'A high energy custom racing blend', work:'racing'},
    breeding:{head:'A custom breeding and growth blend', work:'for breeding or growth'}
  };
  /* which KP ingredients a blend like this is built from. names only, no amounts
     (amounts are formulation, that is the engine). lightly leaned by workload. */
  var INGREDIENTS = {
    spelling: ['Lucerne pellet','Oaten chaff','Steam rolled barley','Faba bean','KP vitamin and mineral pellet','Salt'],
    pretrain: ['Whole oats','Steam rolled barley','Sliced corn','Faba bean','Lucerne pellet','Cold pressed canola oil','KP vitamin and mineral pellet'],
    training: ['Whole oats','Steam rolled barley','Sliced corn','Black sunflower','Faba bean','Lucerne pellet','Cold pressed canola oil','KP vitamin and mineral pellet'],
    racing: ['Whole oats','Steam rolled barley','Sliced corn','Black sunflower','Faba bean','Lucerne pellet','Cold pressed canola oil','KP vitamin and mineral pellet'],
    breeding: ['Lucerne pellet','Faba bean','Sliced corn','Black sunflower','Cold pressed canola oil','KP vitamin and mineral pellet']
  };

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function FF(root){
    this.root = root;
    var cfgEl = root.querySelector('.ff-config'), cfg = {};
    if(cfgEl){ try { cfg = JSON.parse(cfgEl.textContent); } catch(e){} }
    this.cfg = cfg;
    this.A = { issues: [] };
    this.build();
  }

  FF.prototype.name = function(){ return (this.A.name && this.A.name.trim()) ? this.A.name.trim() : 'your horse'; };

  FF.prototype.opts = function(key, arr){
    return '<div class="ff-opts" data-group="'+key+'">' + arr.map(function(o){
      return '<button type="button" class="ff-opt" data-key="'+key+'" data-value="'+o.k+'">'+
        '<span>'+o.t+(o.s?'<small>'+o.s+'</small>':'')+'</span><span class="ff-tick">&#10003;</span></button>';
    }).join('') + '</div>';
  };
  FF.prototype.issuesOpts = function(){
    return '<div class="ff-opts" data-group="issues">' + ISSUES.map(function(o){
      return '<button type="button" class="ff-opt" data-issue="'+o.k+'"><span>'+o.t+'</span><span class="ff-tick">&#10003;</span></button>';
    }).join('') + '</div>';
  };
  FF.prototype.nm = function(){ return '<span class="ff-name">your horse</span>'; };

  FF.prototype.build = function(){
    var heading = this.cfg.heading || "Build the right feed for your horse.";
    var intro = this.cfg.intro || "Milled from premium ingredients, lab tested and traceable batch to batch. The nutrition that has fed champions since 1955, now built around yours. Answer a few quick questions to begin.";
    var H =
      '<div class="ff-intro"><h2 class="ff-h font-heading">'+esc(heading)+'</h2><p class="ff-sub">'+esc(intro)+'</p></div>'+
      '<div class="ff-q"><label class="ff-label">First up, what\'s your horse\'s name?</label>'+
        '<input id="ff-nm" class="ff-input" type="text" placeholder="Horse\'s name" autocomplete="off"></div>'+
      '<div class="ff-q"><label class="ff-label">What is '+this.nm()+' doing right now?</label>'+this.opts('workload',WORKLOADS)+'</div>'+
      '<div class="ff-q"><label class="ff-label">Roughly how big is '+this.nm()+'?</label>'+this.opts('weight',WEIGHTS)+'</div>'+
      '<div class="ff-q"><label class="ff-label">How does '+this.nm()+' hold condition?</label>'+this.opts('doer',DOERS)+'</div>'+
      '<div class="ff-q"><label class="ff-label">Anything to manage with '+this.nm()+'?</label>'+this.issuesOpts()+'</div>'+
      '<div class="ff-q"><label class="ff-label">What is '+this.nm()+' eating now?</label>'+
        '<textarea id="ff-diet" class="ff-input" placeholder="e.g. 4kg oats, 2 biscuits lucerne, a scoop of supplement, ad lib hay"></textarea></div>'+
      '<div class="ff-pick ff-pick--empty"></div>'+
      '<div class="ff-q"><label class="ff-label">Send '+this.nm()+'\'s recipe and price to:</label>'+
        '<input id="ff-first" class="ff-input" type="text" placeholder="First name" autocomplete="given-name">'+
        '<input id="ff-last" class="ff-input" type="text" placeholder="Last name" autocomplete="family-name">'+
        '<input id="ff-email" class="ff-input" type="email" placeholder="Email" autocomplete="email">'+
        '<input id="ff-phone" class="ff-input" type="tel" placeholder="Phone" autocomplete="tel"></div>'+
      '<div class="ff-q"><label class="ff-label">Preferred contact method</label>'+
        '<div class="ff-opts ff-opts--row" data-group="contactPref">'+
          '<button type="button" class="ff-opt" data-key="contactPref" data-value="email"><span>Email</span><span class="ff-tick">&#10003;</span></button>'+
          '<button type="button" class="ff-opt" data-key="contactPref" data-value="phone"><span>Phone</span><span class="ff-tick">&#10003;</span></button>'+
        '</div></div>'+
      '<p class="ff-err" hidden></p>'+
      '<button type="button" class="ff-btn" data-act="submit">Submit</button>';
    this.root.innerHTML = H;
    this.pickEl = this.root.querySelector('.ff-pick');
    this.errEl = this.root.querySelector('.ff-err');

    var self = this;
    this.root.addEventListener('click', function(e){
      var opt = e.target.closest('.ff-opt'); if(opt && self.root.contains(opt)){ self.onOpt(opt); return; }
      var b = e.target.closest('[data-act="submit"]'); if(b){ self.submit(); }
    });
    this.root.addEventListener('input', function(e){
      var t = e.target;
      if(t.id==='ff-nm'){ self.A.name = t.value; self.updateNames(); self.updateResult(); }
      else if(t.id==='ff-diet'){ self.A.diet = t.value; }
      else if(t.id==='ff-first'){ self.A.firstName = t.value; }
      else if(t.id==='ff-last'){ self.A.lastName = t.value; }
      else if(t.id==='ff-email'){ self.A.email = t.value; }
      else if(t.id==='ff-phone'){ self.A.phone = t.value; }
    });
    this.updateResult();
  };

  FF.prototype.onOpt = function(opt){
    var grp = opt.parentNode;
    if(opt.hasAttribute('data-issue')){
      this.toggleIssue(opt.getAttribute('data-issue'));
      var iss = this.A.issues;
      [].forEach.call(grp.children, function(c){ c.classList.toggle('ff-sel', iss.indexOf(c.getAttribute('data-issue'))>=0); });
    } else {
      this.A[opt.getAttribute('data-key')] = opt.getAttribute('data-value');
      [].forEach.call(grp.children, function(c){ c.classList.toggle('ff-sel', c===opt); });
    }
    this.updateResult();
  };

  FF.prototype.toggleIssue = function(k){
    var s = this.A.issues || [];
    if(k==='none'){ s = ['none']; }
    else { s = s.filter(function(x){ return x!=='none'; }); s.indexOf(k)>=0 ? (s = s.filter(function(x){ return x!==k; })) : s.push(k); }
    this.A.issues = s;
  };

  FF.prototype.updateNames = function(){
    var n = this.name();
    [].forEach.call(this.root.querySelectorAll('.ff-name'), function(s){ s.textContent = n; });
  };

  FF.prototype.recommend = function(){
    var b = BLEND[this.A.workload] || BLEND.training, n = esc(this.name());
    var why = 'Formulated around ' + n + ', ' + b.work;
    if(this.A.doer==='hard') why += ', built to keep the weight on';
    else if(this.A.doer==='easy') why += ', kept lean so they do not get too heavy';
    var iss = this.A.issues || [];
    if(iss.indexOf('fizzy')>=0 || iss.indexOf('tieup')>=0) why += ', with the starch kept down';
    if(iss.indexOf('gut')>=0) why += ', with gut support built in';
    var ings = (INGREDIENTS[this.A.workload] || INGREDIENTS.training).slice();
    if(this.A.doer==='hard' && ings.indexOf('Cold pressed canola oil')<0) ings.push('Cold pressed canola oil');
    return { head: b.head, why: why + '.', ings: ings };
  };

  FF.prototype.updateResult = function(){
    if(!this.A.workload){
      this.pickEl.className = 'ff-pick ff-pick--empty';
      this.pickEl.innerHTML = '<p class="ff-why">Answer the questions above and '+esc(this.name())+'\'s custom blend appears here.</p>';
      return;
    }
    var r = this.recommend();
    var chips = r.ings.map(function(i){ return '<span class="ff-ing">'+esc(i)+'</span>'; }).join('');
    this.pickEl.className = 'ff-pick';
    this.pickEl.innerHTML = '<div class="ff-pick-label">'+esc(this.name())+'\'s custom blend</div>'+
      '<p class="ff-feed font-heading">'+esc(r.head)+'</p><p class="ff-why">'+r.why+'</p>'+
      '<div class="ff-ing-label">Built from</div><div class="ff-ings">'+chips+'</div>'+
      '<p class="ff-ing-note">Exact amounts are formulated by KP for your horse.</p>';
  };

  FF.prototype.labelOf = function(arr,k){ for(var i=0;i<arr.length;i++){ if(arr[i].k===k) return arr[i].t; } return ''; };

  FF.prototype.submit = function(){
    var first = (this.A.firstName||'').trim(), last = (this.A.lastName||'').trim();
    var em = (this.A.email||'').trim(), ph = (this.A.phone||'').trim(), pref = this.A.contactPref;
    var n = esc(this.name()), err = '';
    if(!first || !last) err = 'Pop your name in so we know who to send it to.';
    else if(!pref) err = 'Pick how you would like us to get back to you.';
    else if(pref==='email' && !em) err = 'Add your email so we can send '+this.name()+'’s blend.';
    else if(pref==='phone' && !ph) err = 'Add your phone so we can call you about '+this.name()+'.';
    if(err){ this.errEl.hidden = false; this.errEl.textContent = err; this.errEl.scrollIntoView({behavior:'smooth', block:'center'}); return; }

    var via = pref==='phone' ? 'give you a call' : 'send it to your email';
    var msg = 'Thanks '+esc(first)+'. We will formulate '+n+'’s blend, work out the price, and '+via+' with it. A 200kg minimum, made fresh to order.';
    var parts = [this.labelOf(WORKLOADS,this.A.workload), this.labelOf(WEIGHTS,this.A.weight), this.labelOf(DOERS,this.A.doer)].filter(Boolean).map(esc);
    if(this.A.issues && this.A.issues.length) parts.push(esc(this.A.issues.join(', ')));
    var contactBits = []; if(em) contactBits.push(esc(em)); if(ph) contactBits.push(esc(ph));
    /* live build: POST the submission to the data endpoint here. inert in preview. */
    this.root.innerHTML =
      '<div class="ff-intro"><p class="ff-pick-label">Thank you</p><h2 class="ff-h font-heading">Got it.</h2><p class="ff-sub">'+msg+'</p></div>'+
      '<div class="ff-pick"><div class="ff-pick-label">Captured for KP (the real point)</div>'+
      '<p class="ff-why">'+esc(first)+' '+esc(last)+' · <b>'+n+'</b>'+(parts.length?'<br>'+parts.join(' · '):'')+
      (this.A.diet?'<br>Now feeding: '+esc(this.A.diet):'')+'<br>Contact: '+(contactBits.join(' · ')||'(not given)')+' (prefers '+esc(pref||'')+')</p></div>';
    this.root.scrollIntoView({behavior:'smooth', block:'start'});
  };

  function initAll(ctx){
    (ctx||document).querySelectorAll('[data-feed-finder]').forEach(function(root){
      if(root.__ff) return; root.__ff = true; new FF(root);
    });
  }
  window.FeedFinder = { init: initAll };
  if(document.readyState!=='loading') initAll(); else document.addEventListener('DOMContentLoaded', function(){ initAll(); });
})();
